import { useParams, useNavigate } from 'react-router-dom';

export const useLogoClick = () => {
  const nav = useNavigate();
  const params = useParams();
  const URI = params['*'].split('/');
  const account = URI && URI[0] === 'accounts' ? URI[1] : null;

  const logoClick = () => {
    if (account && account === 'all') {
      nav(`accounts`);
    } else if (account) {
      nav(`accounts/${account}/overview`);
    } else {
      nav(`accounts`);
    }
  };

  return { logoClick };
};

export default useLogoClick;
